























































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {PodesavanjeSistema, StavkaDokumenta} from "@/services/BackendProxies";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {focusCena} from "@/utils/focusFunctions";
import {formatPrice} from "@/utils/formatters";
import {State} from "vuex-class";

@Component({})
export default class ServisneOperacijeFaktureBezRadnogNaloga extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop() servisneOperacije!: StavkaDokumenta[];
    @State podesavanjeSistema: PodesavanjeSistema;

    dodajStavku() {
        this.servisneOperacije.push(StavkaDokumenta.fromJS({servisnaOperacija: '',  iznos: 0, pdvStopa: this.podesavanjeSistema.pdvStopa}));
    }

    obrisiStavku(stavka: StavkaDokumenta) {
        this.obrisanaServisnaOperacija(stavka);
    }

    @Emit() obrisanaServisnaOperacija(servisnaOperacija: StavkaDokumenta) {}

    @Watch('servisneOperacije', {deep: true}) onFakturisaniDeloviChange(value: StavkaDokumenta[]) {
        value.forEach(s => {
            s.osnovica = (s.kolicina * s.cena) * (1 - (s.rabat || 0) / 100);
            s.pdv = s.osnovica * s.pdvStopa / 100;
            s.iznos = s.osnovica + s.pdv;
        });
    }

    izabranaServisnaOperacija(vrstaOdrzavanja, stavka: StavkaDokumenta) {
        stavka.vrstaOdrzavanjaId = vrstaOdrzavanja;
    }

    fokusirajCeliju(dataCellValue) {
        this.$nextTick(() => {
            $(`[data-cell="${dataCellValue}"]`).focus();
        });
    }
}
